import { render, staticRenderFns } from "./chip-quarternary.vue?vue&type=template&id=be996e42&scoped=true&"
import script from "./chip-quarternary.vue?vue&type=script&lang=js&"
export * from "./chip-quarternary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be996e42",
  null
  
)

export default component.exports